import { render, staticRenderFns } from "./CardView.vue?vue&type=template&id=21364114&scoped=true&"
import script from "./CardView.vue?vue&type=script&lang=js&"
export * from "./CardView.vue?vue&type=script&lang=js&"
import style0 from "./CardView.vue?vue&type=style&index=0&id=21364114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21364114",
  null
  
)

export default component.exports